import React from 'react';
import { useLocation } from 'react-router-dom';
import t from '~t';
import _ from 'lodash';
import { target } from '~target';
import config from '~config';
import { useSelector } from 'react-redux';
import { user as getUser, isPro } from '~data/selectors/user';
import { API_ENDPOINT_URL } from '~data/constants/app';

import { Label, Checkbox, Alert, Icon } from '~ui';

export default function SettingsBackupsCloud() {
  const user = useSelector(getUser);
  const pro = useSelector(isPro);
  const { pathname } = useLocation();
  const webApp = target == 'web';

  return (
    <>
      <Label>{t.s('cloudBackup')}</Label>

      <div>
        {!webApp && (
          <Alert variant='warning'>
            {t.s('openWebAppBackup')}{' '}
            <a href={`${config.links.app.index}${pathname}`} target='_blank'>
              {t.s('openInBrowser')}
            </a>
          </Alert>
        )}

        {['dropbox', 'gdrive', 'onedrive'].map((key) => {
          const enabled = user[key] && user[key].enabled;

          return (
            <Checkbox
              key={key}
              checked={enabled}
              disabled={!pro || !webApp}
              onChange={() =>
                (window.location = `${API_ENDPOINT_URL}user/connect/${key}/${
                  enabled ? 'revoke' : ''
                }`)
              }
              className={enabled ? 'ui-cloud-enabled' : 'ui-cloud-default'}
            >
              <Icon name={key} className={'ui-cloud-icon' + ' ' + key} />
              {_.capitalize(key)}
            </Checkbox>
          );
        })}
      </div>
    </>
  );
}
